import type { SVGProps } from "react";
import React from "react";

/** Sliders, the glyph the design uses for "open the filters". */
export function FiltersIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path d="M3 6h9M15 6h2M3 14h2M8 14h9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      <circle cx="13.5" cy="6" r="2.25" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <circle cx="6.5" cy="14" r="2.25" stroke="currentColor" strokeWidth="1.5" fill="none" />
    </svg>
  );
}
